import React, { Component } from "react";
import styles from "./unitInfoData.module.scss";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { withUnits } from "../../../shared/containers/containerUnits";
import TextField from "@mui/material/TextField";
import { states } from "../../../reducers/queriesStates";
import { withAuth } from "../../../shared/containers/containerAuth";

class UnitInfoData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.currentUnit.title,
      registerNumber: props.currentUnit.registerNumber,
      number: props.currentUnit.number,
      isChange: false,
      properties: props.currentUnit.properties,
    };
  }

  componentDidUpdate(preProps) {
    const { updateUnitInformationDataState } = this.props;

    if (updateUnitInformationDataState === states.READY && preProps.updateUnitInformationDataState === states.REQUEST) {
      this.setState({ isChange: false });
    }
  }

  onSaveHandler() {
    const { onUpdatgeUnitInformation, currentUnit } = this.props;
    const { title, registerNumber, number, properties } = this.state;

    const _properties = {};

    properties.forEach((x) => {
      _properties[x.id] = x.value;
    });

    onUpdatgeUnitInformation(currentUnit.id, {
      title,
      registerNumber,
      number,
      properties: _properties,
    });
  }

  onChangeProperty(key, value) {
    const { properties } = this.state;
    properties[key].value = value;

    this.setState({ properties, isChange: true });
  }

  render() {
    const { currentUnit, data } = this.props;
    const { title, registerNumber, number, isChange, properties } = this.state;
    const disabled = !data.permissions.includes(11021);

    return (
      <div className={styles.unitInfoDataContainer}>
        <div className={styles.buttonContainer}>
          {isChange && !disabled ? <ButtonPrimary handleClick={this.onSaveHandler.bind(this)} title="Обновить" /> : null}
        </div>

        <div className={styles.unitPropertiesContainer}>
          <div>
            <TextField
              id="outlined-basic"
              label="Номер в списке"
              variant="outlined"
              value={number}
              type="number"
              disabled={disabled || currentUnit.inActive}
              onChange={(e) => {
                this.setState({ number: e.target.value, isChange: true });
              }}
            />
          </div>

          <div>
            <TextField
              id="outlined-basic"
              label="Марка"
              variant="outlined"
              value={title}
              disabled={disabled}
              onChange={(e) => {
                this.setState({ title: e.target.value, isChange: true });
              }}
            />
          </div>

          <div>
            <TextField
              id="outlined-basic"
              label="Гос номер"
              variant="outlined"
              value={registerNumber}
              disabled={disabled}
              onChange={(e) => {
                this.setState({ registerNumber: e.target.value, isChange: true });
              }}
            />
          </div>

          {Object.keys(properties).map((key) => {
            return (
              <div key={key}>
                <TextField
                  id="outlined-basic"
                  label={properties[key].title}
                  variant="outlined"
                  value={properties[key].value}
                  type="text"
                  disabled={disabled}
                  onChange={(e) => {
                    this.onChangeProperty(key, e.target.value);
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default withAuth(withUnits(React.memo(UnitInfoData)));
